import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b3c1049e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "storehouse" }
const _hoisted_2 = { class: "storehouse_top" }
const _hoisted_3 = { class: "storehouse_top_title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "组件库", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "storehouse_top_tips" }, "可拖拽改变顺序", -1))
const _hoisted_6 = { class: "storehouse_list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "list_btn_text" }
const _hoisted_9 = { class: "storehouse_list" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "list_btn_text" }

import { ref } from 'vue';
import Draggable from 'vuedraggable';
import { CaretRightOutlined } from '@ant-design/icons-vue';
import { Collapse } from 'ant-design-vue';
import emitter from '@/utils/mitt';
import moment from 'moment';
import { dragDrop } from '@/utils/format/dragDrop';


export default /*#__PURE__*/_defineComponent({
  __name: 'Storehouse',
  emits: ['getVisualization'],
  setup(__props, { emit }) {

const aCollapse = Collapse;
const aCollapsePanel = aCollapse.Panel;

const showCollapse = ref(['1']);
const subassemblyList = ref([
  {
    type: 0,
    name: '轮播图',
    icon: 'rotationChart',
    rotationChart: {
      type: 0,
      interval: 3000,
      indicatorType: 0,
    },
    rotationChartList: [
      {
        id: 0,
        img: '',
        loading: false,
        type: 0,
        imgId: 0,
        jump: {
          content: false,
          title: '',
          titleColor: '#16B9FA',
          subtitle: '',
          subtitleColor: '#16B9FA',
          profiles: '',
          profilesColor: '#FFFFFF',
          btn: false,
          btnColor: '#16B9FA',
          btnName: '查看',
          btnNameColor: '#FFF',
          link: false,
          jump: 0, //0站内，1站外
          insideLink: undefined,
          outsideLink: '',
          timing: false,
          timeChoice: 0,
          startTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
          endTime: moment(new Date(new Date().valueOf() + 1 * 24 * 60 * 60 * 1000)).format('YYYY-MM-DD HH:mm:ss'),
        },
      },
    ],
  },
  {
    type: 1,
    name: '魔方导航',
    icon: 'navigation',
    content: {
      navType: 0,
      title_type: 0,
      radius_type: 1,
      title_color: '#505D6F',
      title_default_color: '',
    },
    navList: [
      {
        icon: '',
        icon_type: 0,
        title_type: false,
        title: '默认文字',
        bg_type: 0,
        default_bg_color: '#DCDFE6',
        bg_color: '#DCDFE6',
        bg_img: '',
        jump_type: 0,
        jump_link: '',
        jump: {
          jump: 0, //0站内，1站外
          insideLink: undefined,
          inSpecificLink: undefined,
          outsideLink: '',
        },
      },
      {
        icon: '',
        icon_type: 0,
        title_type: false,
        title: '默认文字',
        bg_type: 0,
        default_bg_color: '#DCDFE6',
        bg_color: '#617EFE',
        bg_img: '',
        jump_type: 0,
        jump_link: '',
        jump: {
          jump: 0, //0站内，1站外
          insideLink: undefined,
          inSpecificLink: undefined,
          outsideLink: '',
        },
      },
      {
        icon: '',
        icon_type: 0,
        title_type: false,
        title: '默认文字',
        bg_type: 0,
        default_bg_color: '#DCDFE6',
        bg_color: '#FF5F5F',
        bg_img: '',
        jump_type: 0,
        jump_link: '',
        jump: {
          jump: 0, //0站内，1站外
          insideLink: undefined,
          inSpecificLink: undefined,
          outsideLink: '',
        },
      },
      {
        icon: '',
        icon_type: 0,
        title_type: false,
        title: '默认文字',
        bg_type: 0,
        default_bg_color: '#DCDFE6',
        bg_color: '#00CCB0',
        bg_img: '',
        jump_type: 0,
        jump_link: '',
        jump: {
          jump: 0, //0站内，1站外
          insideLink: undefined,
          inSpecificLink: undefined,
          outsideLink: '',
        },
      },
      {
        icon: '',
        icon_type: 0,
        title_type: false,
        title: '默认文字',
        bg_type: 0,
        default_bg_color: '#DCDFE6',
        bg_color: '#19BDFF',
        bg_img: '',
        jump_type: 0,
        jump_link: '',
        jump: {
          jump: 0, //0站内，1站外
          insideLink: undefined,
          inSpecificLink: undefined,
          outsideLink: '',
        },
      },
    ],
  },
  {
    type: 2,
    name: '正在直播',
    icon: 'live',
    style: 0, //展示样式
    title: '正在直播', //模块标题
    most: 4, //最多显示
    liveList: [],
  },
  {
    type: 3,
    name: '我的文章',
    icon: 'article',
    title: '我的文章', //模块标题
    style: 1, //展示样式
    most: 4, //最多显示
    sortId: '', // 分类id
    articleList: [
      {
        article_kv: '',
        release_time: '',
        title: '',
        browse: null,
        lable: '',
      },
    ],
  },
  {
    type: 4,
    name: '我的图片',
    icon: 'myImg',
    content: {
      title: '我的图片', //模块标题
      style: 2, //排列样式
      most: 4, //最多显示
      title_type: 0,
      title_default_color: '#505D6F',
      title_color: '#505D6F',
      bg_type: 0,
      default_bg_color: '#f7f8fa',
      bg_color: '#DCDEE0',
      bg_img: '',
    },
    imgList: [
      {
        id: 0,
        url: '',
      },
      {
        id: 1,
        url: '',
      },
      {
        id: 2,
        url: '',
      },
      {
        id: 3,
        url: '',
      },
    ],
  },
  {
    type: 5,
    name: '我的直播',
    icon: 'myLive',
    style: 0, //展示样式
    title: '我的直播', //模块标题
    most: 4, //最多显示
    liveList: [
      {
        id: 0,
        style: 0,
        image_player_cover_url: '',
        mode: null,
        start_at: '',
        status: null,
        title: '',
        number: null,
        live_url_status: null,
      },
    ],
  },
]);

const styleList = ref([
  {
    type: 6,
    name: '横向标签',
    icon: 'horizontalLabel',
    style: 0,
    tabsListClick: 0,
    tabsList: [
      {
        id: 0,
        title: '标签1',
        checked: false,
        edit: false,
        nestedList: [
          {
            id: 0,
          },
        ],
      },
      {
        id: 1,
        title: '标签2',
        checked: false,
        edit: false,

        nestedList: [
          {
            id: 1,
          },
        ],
      },
      {
        id: 2,
        title: '标签3',
        checked: false,
        edit: false,
        nestedList: [
          {
            id: 2,
          },
        ],
      },
      {
        id: 3,
        title: '标签4',
        checked: false,
        edit: false,
        nestedList: [
          {
            id: 3,
          },
        ],
      },
    ],
    senior: {
      defaultLabel: '0',
      defaultLabelColor: '#F2F3F7',
      defaultText: '0',
      defaultTextColor: '#00CCB0',
      selectLabel: '0',
      selectLabelColor: '#00CCB0',
      selecttText: '0',
      selecttTextColor: '#00CCB0',
    },
  },
  {
    type: 7,
    name: '折叠标签',
    icon: 'collapseLabel',
    style: 0,
    title: '折叠标签',
    showTitle: false,
    tabsList: [
      {
        id: 0,
        title: '标签1',
        checked: false,
        edit: false,
        nestedList: [
          {
            id: 0,
          },
        ],
      },
    ],
    senior: {
      defaultLabel: '0',
      defaultLabelColor: '#00CCB0',
      defaultText: '0',
      defaultTextColor: '#00CCB0',
      selectLabel: '0',
      selectLabelColor: '#00CCB0',
      selecttText: '0',
      selecttTextColor: '#00CCB0',
    },
  },
]);

// 克隆
const cloneList = (e: any) => {
  const data = JSON.parse(JSON.stringify(e));
  return data;
};
// 组件管理

const getVisualization = () => {
  const data = {
    type: -2,
    name: '组件管理',
  };
  emitter.emit('custom', data);
  emitter.emit('display', true);
  emit('getVisualization');
};

// 添加模块重排
const reset = ref(false);
const typeList = ref([0, 1, 2, 3, 4, 5, 6, 7]);
emitter.on('resetModule', (e: any) => {
  reset.value = e;
  typeList.value = e ? [2, 3, 4, 5] : [0, 1, 2, 3, 4, 5, 6, 7];
});

emitter.on('liveList', (e: any) => {
  const liveList = JSON.parse(JSON.stringify(e));
  liveList.map((item: any) => (item.style = 0));
  subassemblyList.value[2].liveList = liveList;
});

const type = ref();
const clickBtn = (e: any) => {
  type.value = e;
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_svg_icon, { "icon-class": "storehouse" }),
        _hoisted_4
      ]),
      _hoisted_5
    ]),
    _createVNode(_unref(aCollapse), {
      class: "storehouse_collapse",
      activeKey: showCollapse.value,
      "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((showCollapse).value = $event)),
      bordered: false
    }, {
      expandIcon: _withCtx(({ isActive }) => [
        _createVNode(_unref(CaretRightOutlined), {
          rotate: isActive ? 90 : 0
        }, null, 8, ["rotate"])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(aCollapsePanel), {
          key: "1",
          header: "基础组件"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Draggable), {
              list: subassemblyList.value,
              group: { name: 'subassembly', pull: 'clone', put: false },
              "item-key": "id",
              sort: false,
              animation: 150,
              clone: cloneList,
              onDrop: _unref(dragDrop)
            }, {
              item: _withCtx(({ element }) => [
                _withDirectives(_createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["storehouse_list_btn", element.type == type.value ? 'list_btn_click' : '']),
                    onClick: ($event: any) => (clickBtn(element.type))
                  }, [
                    _createVNode(_component_svg_icon, {
                      "icon-class": element.icon
                    }, null, 8, ["icon-class"]),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(element.name), 1)
                  ], 10, _hoisted_7)
                ], 512), [
                  [_vShow, typeList.value.indexOf(element.type) !== -1]
                ])
              ]),
              _: 1
            }, 8, ["list", "onDrop"])
          ]),
          _: 1
        }),
        (!reset.value)
          ? (_openBlock(), _createBlock(_unref(aCollapsePanel), {
              key: "2",
              header: "排列样式"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Draggable), {
                  list: styleList.value,
                  group: { name: 'subassembly', pull: 'clone', put: false },
                  "item-key": "id",
                  sort: false,
                  animation: 150,
                  clone: cloneList,
                  onDrop: _unref(dragDrop)
                }, {
                  item: _withCtx(({ element }) => [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["storehouse_list_btn", element.type == type.value ? 'list_btn_click' : '']),
                        onClick: ($event: any) => (clickBtn(element.type))
                      }, [
                        _createVNode(_component_svg_icon, {
                          "icon-class": element.icon
                        }, null, 8, ["icon-class"]),
                        _createElementVNode("div", _hoisted_11, _toDisplayString(element.name), 1)
                      ], 10, _hoisted_10)
                    ])
                  ]),
                  _: 1
                }, 8, ["list", "onDrop"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["activeKey"]),
    _createElementVNode("div", {
      onClick: getVisualization,
      class: "storehouse_manage"
    }, [
      _createVNode(_component_svg_icon, { "icon-class": "manage" }),
      _createTextVNode(" 组件管理")
    ])
  ]))
}
}

})